import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { CreateCampaignComponent } from './modules/create-campaign/container/create-campaign.component';
import { CampaignsListComponent } from './modules/campaigns-list/container/campaigns-list.component';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/authentication/authentication.routes').then(m => m.AUTHENTICATION_ROUTES)
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: 'create-campaign', component: CreateCampaignComponent },
      { path: 'campaign-status', component: CampaignsListComponent },
      {
        path: 'avatars',
        loadChildren: () =>
          import('./modules/avatars/avatars.routes').then(m => m.AVATARS_ROUTES)
      },
      {
        path: 'groups-dashboard',
        loadChildren: () =>
          import('./modules/groups/groups.routes').then(m => m.GROUPS_ROUTES)
      },
      { path: '', redirectTo: 'create-campaign', pathMatch: 'full' }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
